import { createApp } from 'vue';
import Slider from './slider.vue';

const sliderElement = document.getElementById('testimonials-slider');

if (sliderElement) {
    const testimonialsDataElement = document.getElementById('testimonials-data');
    let testimonialsData = [];

    if (testimonialsDataElement) {
        try {
            testimonialsData = JSON.parse(testimonialsDataElement.textContent);
        } catch (e) {
            testimonialsData = [];
        }
    }

    createApp(Slider, {
        testimonialsSource: testimonialsData,
    }).mount('#testimonials-slider');
}
